/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, Input, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, TranslatePipe],
})
export class DropdownComponent implements OnInit {
  readonly label = input<string>();
  readonly options = input<any[]>();
  @Input() translationLocation?: string;
  readonly size = input<number>();
  readonly defaultOption = input<any>();
  readonly changed = output();

  public selectedOption: any;

  ngOnInit(): void {
    this.selectDefaultOption();
  }

  public handleChange(): void {
    this.changed.emit(this.selectedOption);
  }

  public getFieldSize(): string {
    switch (this.size()) {
      case 100:
        return 'dropdown--100';
      case 80:
        return 'dropdown--80';
      case 60:
        return 'dropdown--60';
      case 40:
        return 'dropdown--40';
      case 20:
        return 'dropdown--20';
      default:
        return 'dropdown--50';
    }
  }

  protected updateSelectedOption(option: any): void {
    this.selectedOption = option;
  }

  private selectDefaultOption(): void {
    const defaultOption = this.defaultOption();
    if (!defaultOption) {
      return;
    }

    this.selectedOption = defaultOption;
    this.handleChange();
  }
}
